import { BaseListWebService } from '../../../shared/components/base-list-web/base-list-web.service';
import { Component, Input } from '@angular/core';
import { BaseListWebComponent } from '@web/base/shared/components/base-list-web/base-list-web.component';
import { ConstantsProject } from '@web/project/shared/constants.class';
import { Observable } from 'rxjs';

@Component({
  selector: 'web-home-grid-content',
  templateUrl: './grid-content.component.html',
  styleUrls: ['./grid-content.component.scss'],
  providers: [BaseListWebService]
})
export class GridContentComponent extends BaseListWebComponent {
  @Input() content$: Observable<Array<any>>;
  @Input() classList: String;

  itemKeyName = 'elementID';

  public COVER_ELEMENT_TYPE_CONTENTS = ConstantsProject.COVER_ELEMENT_TYPE_CONTENTS;

  getData() {
    this.subscriptions.push(
      this.content$.subscribe(content => {
        this.items$.next(
          content.map(c => {
            const image = c.files.find(f => f.name === 'image');
            c.image = image && image.url ? image.url : '../../../../../../assets/img/default.webp';
            c.observatoryName = c.observatoryName || 'cositalnetwork';
            c.categoryName = c.categoryName && c.categoryName !== 'Páginas estáticas' ? c.categoryName : 'cositalnetwork';

            return c;
          })
        );
      })
    );
  }

}
